/**
 * 帮助中心文档目录（正文见 src/content/help/articles.js，由 src/content/help/source/ 下 Word 文档构建）
 */
const TWITTER_HANDLE = String(process.env.VUE_APP_TWITTER_HANDLE ?? 'DeepSage').replace(/^@/, '');

export const HELP_SOCIAL_LINKS = {
  telegram: {
    handle: 'DeepSage_Official',
    url: 'https://t.me/DeepSage_Help',
  },
  twitter: {
    handle: TWITTER_HANDLE,
    url: 'https://x.com/DeepSageApp',
  },
  email: {
    address: 'service@deepsage.app',
    url: 'mailto:service@deepsage.app',
  },
  instagram: {
    url:
      String(process.env.VUE_APP_INSTAGRAM_URL ?? '').trim() ||
      'https://www.instagram.com/deepsage',
  },
  discord: {
    url: String(process.env.VUE_APP_DISCORD_URL ?? '').trim() || 'https://discord.gg/deepsage',
  },
  tiktok: {
    url: String(process.env.VUE_APP_TIKTOK_URL ?? '').trim() || 'https://www.tiktok.com/@deepsage',
  },
};

/** 帮助中心文档卡片（3×2 网格，顺序与设计稿一致） */
export const HELP_DOCUMENT_CATALOG = [
  {
    id: 'terms',
    titleKey: 'helpPage.docs.terms.title',
    descKey: 'helpPage.docs.terms.desc',
    tone: 'blue',
  },
  {
    id: 'privacy',
    titleKey: 'helpPage.docs.privacy.title',
    descKey: 'helpPage.docs.privacy.desc',
    tone: 'green',
  },
  {
    id: 'documentation',
    titleKey: 'helpPage.docs.documentation.title',
    descKey: 'helpPage.docs.documentation.desc',
    tone: 'purple',
  },
  // {
  //   id: 'trading-guide',
  //   titleKey: 'helpPage.docs.tradingGuide.title',
  //   descKey: 'helpPage.docs.tradingGuide.desc',
  //   tone: 'orange',
  // },
  // {
  //   id: 'risk-disclosure',
  //   titleKey: 'helpPage.docs.riskDisclosure.title',
  //   descKey: 'helpPage.docs.riskDisclosure.desc',
  //   tone: 'red',
  // },
  // {
  //   id: 'cookie-policy',
  //   titleKey: 'helpPage.docs.cookiePolicy.title',
  //   descKey: 'helpPage.docs.cookiePolicy.desc',
  //   tone: 'yellow',
  // },
];

/** 保留子页面路由：充值提现等（不在首页网格展示） */
export const HELP_DOCUMENT_EXTRA = [
  {
    id: 'deposit-withdraw',
    titleKey: 'helpPage.docs.depositWithdraw.title',
    descKey: 'helpPage.docs.depositWithdraw.desc',
    icon: 'wallet',
    tone: 'blue',
  },
];

export const HELP_ALL_DOCUMENTS = [...HELP_DOCUMENT_CATALOG, ...HELP_DOCUMENT_EXTRA];

export function getHelpDocumentById(id) {
  const slug = String(id ?? '').trim();
  return HELP_ALL_DOCUMENTS.find((item) => item.id === slug) ?? null;
}
